module.exports = __webpack_public_path__ + "media/images/logo-icon-21a21c450834ffc7848286f58080388a.png";